<template>
  <!-- 企业资质 -->
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="submit">保存</el-button>
    </div>
    <!-- 营业执照 -->
    <div class="infoDiv">
      <div class="h3title">营业执照</div>
      <el-form ref="baseInForm" label-width="110px" class="glo_formBox">
        <el-form-item label="企业名称:">
          <el-input v-model="businessIssuing.name" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="营业执照号:">
          <el-input v-model="businessIssuing.employmentNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="核发机关:">
          <el-input v-model="businessIssuing.issuingAuthority" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="发证日期:" label-width="120px">
          <el-date-picker v-model="businessIssuing.issuingDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="生效日期:" label-width="120px">
          <el-date-picker v-model="businessIssuing.validDateStart" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="到期日期:" label-width="120px">
          <el-date-picker v-model="businessIssuing.validDateEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <div class="uploadBox">
          <div class="uploadItem">
            <div class="uploadLaber">营业执照图片:</div>
            <uploadimgs @input="changeFileList1" :fileNameLists="fileNameLists1" :limit="9"></uploadimgs>
          </div>
        </div>
      </el-form>
      <!-- 运单信息 -->
      <div class="infoDiv">
        <div class="h3title">经营许可证</div>
        <el-form label-width="110px" class="glo_formBox">
          <el-form-item label="业户名称:">
            <el-input v-model="xukeZheng.name" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="营运证号:">
            <el-input v-model="xukeZheng.employmentNumber" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="核发机关:">
            <el-input v-model="xukeZheng.issuingAuthority" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="发证日期:" label-width="120px">
            <el-date-picker v-model="xukeZheng.issuingDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="生效日期:" label-width="120px">
            <el-date-picker v-model="xukeZheng.validDateStart" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="到期日期:" label-width="120px">
            <el-date-picker v-model="xukeZheng.validDateEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="经营范围:">
            <el-input type="textarea" rows="2" v-model="xukeZheng.businessNature" />
          </el-form-item>
          <div class="uploadBox">
            <div class="uploadItem">
              <div class="uploadLaber">许可证图片:</div>
              <uploadimgs @input="changeFileList2" :fileNameLists="fileNameLists2" :limit="9"></uploadimgs>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  inject: ["reload"],
  components: {
    uploadimgs,
  },
  data() {
    return {
      fileNameLists1: [],
      fileNameLists2: [],
      businessIssuing: {
        name: "",
        employmentNumber: "",
        issuingAuthority: "",
        issuingDate: "",
        validDateStart: "",
        validDateEnd: "",
        businessNature: "",
      },
      xukeZheng: {
        name: "",
        employmentNumber: "",
        issuingAuthority: "",
        issuingDate: "",
        validDateStart: "",
        validDateEnd: "",
        businessNature: "",
      },
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {
    this.GetData();
  },
  destroyed() {},
  methods: {
    changeFileList1(array) {
      this.fileNameLists1 = array;
    },
    changeFileList2(array) {
      this.fileNameLists2 = array;
    }, // 查看图片
    lookImgs({ qualificationType, fileDocumentNumber, fileDocumentStatus }) {
      this.$API
        .filegetFiles({
          documentType: "",
          documentStatus: fileDocumentStatus,
          documentNumber: fileDocumentNumber,
        })
        .then((res) => {
          let filse = res.data.result || [];
          if (filse && filse.length > 0) {
            let arrs = [];
            arrs = filse.map((item) => {
              return {
                name: item.fileId,
                url: item.fileUrl,
              };
            });
            if (qualificationType == "ying_ye_zhi_zhao:qualification_type") {
              this.fileNameLists1 = arrs;
            }
            if (qualificationType == "xu_ke_zheng:qualification_type") {
              this.fileNameLists2 = arrs;
            }
          }
        });
    },
    async GetData() {
      this.fileNameLists1 = [];
      this.fileNameLists2 = [];
      this.businessIssuing = {
        name: "",
        employmentNumber: "",
        issuingAuthority: "",
        issuingDate: "",
        validDateStart: "",
        validDateEnd: "",
        businessNature: "",
      };
      this.xukeZheng = {
        name: "",
        employmentNumber: "",
        issuingAuthority: "",
        issuingDate: "",
        validDateStart: "",
        validDateEnd: "",
        businessNature: "",
      };
      this.$API
        .runPageReportDetails({
          conditionReqs: [],
          number: "admin_enterprise_info",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas || [];
            datas.forEach((element) => {
              const { qualificationType } = element;
              if (qualificationType == "ying_ye_zhi_zhao:qualification_type") {
                this.businessIssuing = element || {};
              }
              if (qualificationType == "xu_ke_zheng:qualification_type") {
                this.xukeZheng = element || {};
              }
              this.lookImgs(element);
            });
          } else {
            this_.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },
    submit() {
      this.businessIssuing.fileIds = this.fileNameLists1.map((item) => {
        return item.name;
      });
      this.xukeZheng.fileIds = this.fileNameLists2.map((item) => {
        return item.name;
      });
      this.$API
        .saveEnterpriseQualification({
          businessIssuing: this.businessIssuing,
          xukeZheng: this.xukeZheng,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  margin-bottom: 20px;
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .formbox {
    padding: 0 30px;
  }
}

.textArea {
  height: 100%;
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 16px;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}
</style>
